import LazyOption from './lazy-option';

export default LazyOption;
